export default "__VITE_ASSET__BLVYnCil__"